<script setup lang="ts">
import { computed } from "vue";

import BaseModal from "@/components/BaseModal.vue";
import type { Organisation } from "@/types";

import OrganisationTypeIcon from "./OrganisationTypeIcon.vue";

const { organisations } = defineProps<{
  organisations: Organisation[];
}>();

const emit = defineEmits<{
  select: [organisation: Organisation];
}>();

const modalTitle = computed(() => {
  const aggregatorName = organisations[0]?.aggregatorName;

  return aggregatorName || "Vælg organisation";
});
</script>

<template>
  <BaseModal
    v-slot="{ close }"
    fullscreen="sm-down"
    size="lg"
    is-centered
    :title="modalTitle"
  >
    <p class="mb-2">Det valgte område omfatter flere organisationer:</p>
    <div class="list-group list-group-flush mx-n2 bg-danger">
      <a
        v-for="organisation in organisations"
        :key="organisation.id"
        class="d-flex align-items-center gap-2 list-group-item list-group-item-action px-2"
        href="#"
        @click="(close(), emit('select', organisation))"
      >
        <OrganisationTypeIcon :type="organisation.type" class="flex-shrink-0" />
        {{ organisation.name }}
      </a>
    </div>
  </BaseModal>
</template>
